import React, { Component } from 'react';
import axios from 'axios';
import './App.css';

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isReady: false,
			data: [],
			text: '',
			isLoading: false,
			header_label: '',
			conversation_label: '',
			initial_text: '',
			error_msg: '',
			placeholder: '',
		};
		this.bottomRef = React.createRef();
	}

	componentDidMount() {
		this.getinitials();
	}

	// update message on typing
	updateMessage = (evt) => {
		const val = evt.target.value;
		this.setState({ text: val });
	};

	// handle press enter
	handleKeyPress = (evt) => {
		if (evt.key === 'Enter' || evt.keyCode === 13) {
			this.handleSubmit();
		}
	};

	// handle submit message
	handleSubmit = () => {
		if (this.state.text.length > 0) {
			this.setState({ text: '' });
			this.addNewMessage(this.state.text, 1);
			this.setState({ isLoading: true })
			this.getAnswer(this.state.text);
		}
	};

	// push message to array
	addNewMessage = (text, type) => {
		const newMessage = {
			text: text,
			type: type,
			time: this.getCurrentDateTime(),
		};
		const data = this.state.data;
		data.push(newMessage);

		this.setState({ data: data }, () => {
			this.bottomRef.current.scrollIntoView({ behavior: 'smooth' });
		});
	};

	// helper for getting curren date and time
	getCurrentDateTime = () => {
		const now = new Date();
		const day = String(now.getDate()).padStart(2, '0');
		const month = String(now.getMonth() + 1).padStart(2, '0'); // January is 0!
		const year = now.getFullYear();
		const hours = String(now.getHours()).padStart(2, '0');
		const minutes = String(now.getMinutes()).padStart(2, '0');
		const formattedDateTime = `${day}.${month}.${year} ${hours}:${minutes}`;

		return formattedDateTime;
	}

	// get initials form wp endpoint
	getinitials = async () => {
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: '/wp-json/t3/v1/chatbot',
			headers: { }
		};

		axios.request(config)
			.then((response) => {
				if (response) {

					var header_label = response.data.header_label;
					var conversation_label = response.data.conversation_label;
					var initial_text = response.data.initial_text;
					var error_msg = response.data.error_msg;
					var placeholder = response.data.placeholder;

					this.setState({
						header_label: header_label,
						conversation_label: conversation_label,
						initial_text: initial_text,
						error_msg: error_msg,
						placeholder:  placeholder
					})

					if (this.state.data.length < 1) {
						this.addNewMessage(initial_text, 2);
					}
				} else {
					this.setFallback();		
				}
				this.setState({ isLoading: false })
		})
		.catch((error) => {
			console.log(error);
			this.setFallback();
		});		
	}

	// set fallback states if error in wp endpoint
	setFallback = () => {
		this.setState({
			header_label: 'Leeb Balkone GmbH',
			conversation_label: 'Leeb Balkone',
			initial_text: 'Willkommen beim Leeb Balkone GmbH Chatbot! Ich bin hier, um Ihnen bei Fragen zu unseren Produkten zu helfen. Egal ob Sie Informationen benötigen oder Hilfe bei der Auswahl brauchen, zögern Sie nicht, mich zu fragen!',
			error_msg: 'Leider kann ich im Moment nicht antworten.',
			placeholder:  'Stellen Sie eine Frage'
		})

		if (this.state.data.length < 1) {
			this.addNewMessage('Willkommen beim Leeb Balkone GmbH Chatbot! Ich bin hier, um Ihnen bei Fragen zu unseren Produkten zu helfen. Egal ob Sie Informationen benötigen oder Hilfe bei der Auswahl brauchen, zögern Sie nicht, mich zu fragen!', 2);
		}

		this.setState({ isLoading: false })
	}

	// get (stupid) answer from bot
	getAnswer = async (q) => {
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: 'https://leeb-chatbot.leeb-balkone.com?q=' + q,
			headers: { }
		};

		axios.request(config)
			.then((response) => {
				var answer = response.data.response;

		        var answer = response.data.response;

		        // Function to detect links and wrap them with <a> tags
		        const wrapLinksWithAnchorTags = (text) => {
		          const splitText = text.split(/(https?:\/\/\S+)/);

		          return splitText.map((part, index) => {
		            if (part.match(/https?:\/\/\S+/)) {
		              return (
		                <a key={index} href={part} target="_blank" rel="noopener noreferrer">
		                  {part}
		                </a>
		              );
		            } else {
		              return <React.Fragment key={index}>{part}</React.Fragment>;
		            }
		          });
		        };

		        const modifiedResponse = wrapLinksWithAnchorTags(answer);

		        console.log(answer);
		        this.addNewMessage(modifiedResponse, 2);
				this.setState({ isLoading: false })
		})
		.catch((error) => {
			console.log(error);
			this.addNewMessage(this.state.error_msg, 2);
			this.setState({ isLoading: false })
		});		
	}

	// render the stuff
	render() {
		return (
			<div className="app">
				<div className="conversation">
					<div className="header">
						<img className="logo" src="logo192.png" />
						<span>{ this.state.header_label }</span>
					</div>
					{this.state.data.map((message, index) => (
						<div
							key={index}
							className={`message-wrap ${message.type === 1 ? 'me' : 'you'}`}

						>
							{ message.type === 2 &&
								<img className="logo" src="logo192.png" />
							}
								
							<div className="message">
								{ message.type === 2 &&
									<span className="message-sender">{ this.state.conversation_label }</span>
								}
								<span className="message-content">{message.text}</span>
							</div>
							<span className="time">{message.time}</span>
						</div>
					))}
					{ this.state.isLoading &&
						<div className="message-wrap you">
								<img className="logo" src="logo192.png" />
							<div className="message">
								<span className="message-sender">{ this.state.conversation_label }</span>
									<div className="typing"><div className="typing__dot"></div><div className="typing__dot"></div><div className="typing__dot"></div></div>
							</div>
						</div>
					}
					<div ref={this.bottomRef}></div>
				</div>

				<div className="messenger">
					<input
						type="text"
						name="text"
						value={this.state.text}
						className="text"
						onChange={this.updateMessage}
						onKeyPress={this.handleKeyPress}
						placeholder={this.state.placeholder}
					/>
					<div className="submit" onClick={this.handleSubmit}>
						<svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 24 24"><path d="M8.75 17.612v4.638a.751.751 0 0 0 1.354.444l2.713-3.692zM23.685.139a.75.75 0 0 0-.782-.054l-22.5 11.75a.752.752 0 0 0 .104 1.375l6.255 2.138 13.321-11.39L9.775 16.377l10.483 3.583a.753.753 0 0 0 .984-.599l2.75-18.5a.751.751 0 0 0-.307-.722z"/></svg>
					</div>
				</div>
			</div>
		);
	}
}

export default App;

